// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisplayCookieBar {
    display: inline-block;
    background-color: var(--topbarColor);
    text-align: left;
    position: fixed;
    bottom: 0;
    z-index: 400;
    width: 100%;
    padding: 1em;
    -webkit-box-shadow: -2px -1px 15px 7px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: -3px -2px 30px 14px rgba(0, 0, 0, 0.425);
    box-shadow: -4px -3px 45px 21px rgba(0, 0, 0, 0.35);
}

.DisplayCookieBarButtonContainer {
    float: right;
    padding-right: 2em;
}

.DisplayCookieBarText {
    float: left;
}

.DisplayCookieBarHidden {
    display: none;
}

@media only screen and (max-width: 768px) {
    .DisplayCookieBar {
        display: block;
        text-align: center;
        font-size: 15px;
    }

    .DisplayCookieBarButtonContainer {
        float: none;
    }

    .DisplayCookieBarText {
        float: none;
        font-size: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/CookieInfoBar/CookieInfoBar.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yDAAyD;IACzD,yDAAyD;IACzD,mDAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":[".DisplayCookieBar {\n    display: inline-block;\n    background-color: var(--topbarColor);\n    text-align: left;\n    position: fixed;\n    bottom: 0;\n    z-index: 400;\n    width: 100%;\n    padding: 1em;\n    -webkit-box-shadow: -2px -1px 15px 7px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: -3px -2px 30px 14px rgba(0, 0, 0, 0.425);\n    box-shadow: -4px -3px 45px 21px rgba(0, 0, 0, 0.35);\n}\n\n.DisplayCookieBarButtonContainer {\n    float: right;\n    padding-right: 2em;\n}\n\n.DisplayCookieBarText {\n    float: left;\n}\n\n.DisplayCookieBarHidden {\n    display: none;\n}\n\n@media only screen and (max-width: 768px) {\n    .DisplayCookieBar {\n        display: block;\n        text-align: center;\n        font-size: 15px;\n    }\n\n    .DisplayCookieBarButtonContainer {\n        float: none;\n    }\n\n    .DisplayCookieBarText {\n        float: none;\n        font-size: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
